module.exports = __webpack_public_path__ + "img/icon_sm_tkrksh.92633768.png";